import { MessageService } from 'primeng/api';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TableComponent } from 'src/app/shared/components/table/table.component';
import { DrivePlannerService, GlobalService } from '@services';
import { Message, Severity, Summary } from '@enum';
import { RoundTypes } from '@enum';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, doc, updateDoc } from 'firebase/firestore';
import { environment } from 'src/environments/environment';
import * as QRCode from 'qrcode';
import { DriveAttendanceService } from '@services';
import { DownloadFieldOptions } from '../eligibility-criteria/eligibility-criteria.types';
import { modifyDownloadFieldsArray } from 'src/app/shared/utils/helper';
interface IRoundData {
  event_id: string;
  end_date: string;
  start_date: string;
  event_name: string;
  round_type: string;
  date_status: string;
  order_id: number;
  drive_id: string;
  bg_color: string;
  event_type: string;
};

interface GeolocationPositionError {
  code: number; // 1: permission denied, 2: position unavailable, 3: timeout
  message: string;
}

@Component({
  selector: 'app-drive-attendance',
  templateUrl: './drive-attendance.component.html',
  styleUrls: ['./drive-attendance.component.css']
})

export class DriveAttendanceComponent implements OnInit {
  @ViewChild(TableComponent) tableComponent!: TableComponent;
  @Input() driveData: any = {};
  @Input() driveStatus: string = '';

  userData = JSON.parse(localStorage.getItem('user_details') || '{}');
  accountData = JSON.parse(localStorage.getItem('account_details') || '{}');
  accountMetaData = JSON.parse(localStorage.getItem('account_metadata') || '{}');
  generatingQR: boolean = false;
  fetchingLocation: boolean = false;
  showDownload: boolean = false;
  isLoading: boolean = false;
  creatingQR: boolean = false;
  autoRefresh: boolean = false;
  fetchingStudents: boolean = false;
  revokedOnly: boolean = false;
  displayRevokeReason: boolean = false;
  isQrInAnotherTab: boolean = false;
  nextRefreshIn: number = 5;
  allowedRadius: number = 0;
  countdown: number = 10;
  rowsize: number = 10;
  dataCount: number = 0;
  selectedPage: any = 1;
  totalPage: number = 0;
  cycleId: string = '';
  sort_order = 1;
  group_account_id: string = this.accountData?.group_account_id || '';
  downloadColumnAs: string = 'excel';
  gpsFetchMode: 'auto' | 'manual' = 'auto';
  tableHeight: string = '90vh';
  gpsLockStatus: string = '';
  isInstructionDialogOpen: boolean = false;
  searchValue: string = '';
  drive_id: string = '';
  qrCodeUrl: string = '';
  revokeReason: string = '';
  sort_by = '';
  roundTypes = RoundTypes;
  selectedRound: IRoundData | null = null;
  pageLimits: number[] = [10, 25, 50, 100];
  roundData: IRoundData[] = [];
  columns: any[] = [];
  dataList: any[] = [];
  qrRefreshInterval: any;
  refreshTimer: any;
  autoRefreshInterval: any;
  revokePayload = {};
  downloadCategories: any = [{ header: 'Attendance info', data: [], isSelectedAll: false }];
  additionalOptions = [{ value: false, label: 'Only Revoked Students', type: 'revoked' }];
  captionsList: any = { actions: false, columns: true, download: true, filter: false, search: true, pagination: true, header: true, checkbox: true, limit: true, custom_sort: true }
  gpsLock = { lat: null as number | null, lng: null as number | null };
  actionOptions: any[] = [{ item_name: 'Revoke Attendance', type: 'revoke', item_type: 'button' }];
  roundTypesLabel = this.roundTypes.reduce((acc, each) => { acc[each.value] = each.label; return acc; }, {} as any);
  selectedFieldOrder: string[] = [];
  private qrLogDocId: string | null = null;
  private firestore = getFirestore(initializeApp(environment.firebaseConfig));

  constructor(
    public globalService: GlobalService,
    private drivePlannerService: DrivePlannerService,
    private messageService: MessageService,
    private driveAttendanceService: DriveAttendanceService
  ) {
  }

  async ngOnInit() {
    this.isLoading = true;
    this.columns = [
      { field: 'primary_email', header: 'Email', freezable: true, sortable: false, tableDefault: true, width: '14vw' },
      { field: 'name', header: 'Student Name', freezable: false, sortable: true, tableDefault: true, width: '12vw' },
      { field: 'registration_number', header: 'Reg. No.', freezable: false, sortable: true, tableDefault: true, width: '12vw' },
      { field: 'markedAt', header: 'Marked At', freezable: false, sortable: true, tableDefault: true, width: '15vw' },
      { field: 'coordinates', header: 'GPS Coordinates', freezable: false, sortable: false, tableDefault: true, width: '8vw', type: 'coordinates' },
      { field: 'accuracy', header: 'GPS Accuracy (m)', freezable: false, sortable: false, tableDefault: true, width: '12vw' },
      { field: 'device_platform', header: 'Device Platform', freezable: false, sortable: false, tableDefault: true, width: '12vw' },
      { field: 'time_zone', header: 'Device Timezone', freezable: false, sortable: false, tableDefault: true, width: '12vw' },
      { field: 'revoke_reason', header: 'Revoked Reason', freezable: false, sortable: false, tableDefault: true, width: '10vw' },
      { field: 'revoked_by', header: 'Revoked By', freezable: false, sortable: false, tableDefault: true, width: '10vw' },
      { field: 'revoked_at', header: 'Revoked At', freezable: false, sortable: true, tableDefault: true, width: '14vw' }
    ]
    this.drive_id = this.driveData?.drive_id || '';
    await this.fetchRounds();
    await this.fetchAttendance();
    this.isLoading = false;
  }

  async fetchRounds() {
    try {
      const response = await this.drivePlannerService.getEvents({ drive_id: this.drive_id }, 'drive');
      if (!response.success) {
        this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Error Fetching Rounds' });
        return;
      }

      this.roundData = response.data;
      this.selectedRound = this.roundData?.[0] || null;
    } catch (error) {
      console.error('Error in fetchRounds:', error);
      this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Unexpected Error While Fetching Rounds' });
    }
  }

  async fetchAttendance() {
    this.isLoading = true;

    try {
      if (!this.selectedRound) return;

      await Promise.all([
        this.fetchStudentList(),
        this.fetchAttendanceConfig()
      ]);
    } catch (error) {
      console.error('Error in fetchAttendance:', error);
      this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Unexpected Error While Fetching Attendance' });
    } finally {
      this.isLoading = false;
    }
  }

  downloadCustomField() {
    this.showDownload = true;
    this.columns.forEach((column) => {
      this.downloadCategories[0].data.push({
        label: column.header,
        value: column.field,
        active: false
      })
    }
    )
  }

  openInstruction() {
    this.isInstructionDialogOpen = true;
  }

  async tableAction(event: { type: string; student_data: any[]; selectAll: boolean; }) {
    const { selectAll } = event;

    try {
      const payload = {
        drive_id: this.drive_id,
        round_id: this.selectedRound?.event_id,
        group_account_id: this.group_account_id,
        users: this.tableComponent.selectedAll ? [] : this.tableComponent.selectedOptions.map((item: any) => item.user_id),
        selectAll,
        search: this.searchValue,
        sort_by: this.sort_by,
        sort_order: this.sort_order,
        rowSize: this.rowsize,
        page: this.selectedPage,
        limit: this.dataCount,
      };

      if (event.type === 'revoke') {
        this.revokePayload = payload;
        this.displayRevokeReason = true;
        return;
      }

      this.fetchingStudents = true;
      const res: any = await this.driveAttendanceService.revokeOrRestoreStudent(payload, event.type);

      if (res?.success) {
        if (res?.success) {
          this.messageService.add({
            severity: Severity.SUCCESS,
            summary: Summary.SUCCESS,
            detail: 'Selected students’ attendance restored successfully.',
          });
        }
        await this.fetchStudentList();
      } else {
        this.messageService.add({
          severity: Severity.ERROR,
          summary: Summary.ERROR,
          detail: 'Failed to restore attendance.',
        });
      }
    } catch (error: any) {
      console.error('Restore attendance error:', error);
      this.messageService.add({
        severity: Severity.ERROR,
        summary: Summary.ERROR,
        detail: 'Something went wrong while restoring attendance.',
      });
    } finally {
      this.fetchingStudents = false;
    }
  }

  async revokeStudents() {
    this.fetchingStudents = true;
    this.isLoading = true;

    try {
      const res: any = await this.driveAttendanceService.revokeOrRestoreStudent({ ...this.revokePayload, reason: this.revokeReason }, 'revoke');

      if (res?.success) {
        if (res?.success) {
          this.messageService.add({
            severity: Severity.SUCCESS,
            summary: Summary.SUCCESS,
            detail: 'Selected students’ attendance revoked successfully.',
          });
        }
        await this.fetchStudentList();
      } else {
        this.messageService.add({
          severity: Severity.ERROR,
          summary: Summary.ERROR,
          detail: 'Failed to revoke attendance.',
        });
      }
    } catch (error: any) {
      console.error('Revoke attendance error:', error);
      this.messageService.add({
        severity: Severity.ERROR,
        summary: Summary.ERROR,
        detail: 'Something went wrong while revoking attendance.',
      });
    } finally {
      this.fetchingStudents = false;
      this.isLoading = false;
      this.onDialogClose();
    }
  }

  revokeOptionChange(event: any) {
    if (event.item.value) {
      this.actionOptions = [{ item_name: "Restore Attendance", type: 'restore', item_type: 'button' }];
    } else {
      this.actionOptions = [{ item_name: "Revoke Attendance", type: 'revoke', item_type: 'button' }];
    }
    this.tableComponent.resetSelected();
    this.tableComponent.currentPage = 1;
    this.pageChange(1);
    // this.fetchStudentList();
  }

  clearInputs() {
    this.downloadCategories[0].data = []
    this.downloadCategories[0].isSelectedAll = false;
    this.selectedFieldOrder = [];
  }

  async downloadFields() {
    if (!this.dataList.length) {
      this.messageService.add({
        severity: Severity.ERROR,
        summary: Summary.ERROR,
        detail: Message.NOSTUDENTDATA
      });
      return;
    }

    
    try {

      let fields = this.selectedFieldOrder.map(value => {
        const header = this.columns.find(col => col.field === value)?.header ?? value;
        return { header, value };
      });

      if(!fields?.length) {
        this.messageService.add({
          severity: Severity.ERROR,
          summary: Summary.ERROR,
          detail: Message.ATLEASTONEFIELD
        });
        return;
      }

      this.showDownload = false;
      // this.isLoading = true;
      const payload = {
        drive_name: this.driveData.name,
        round_name: this.selectedRound?.round_type,
        drive_id: this.drive_id,
        round_id: this.selectedRound?.event_id,
        group_account_id: this.group_account_id,
        limit: this.dataCount,
        page: this.selectedPage,
        search: this.searchValue,
        downloadAs: this.downloadColumnAs,
        user_id: this.userData.user_id,
        sort_by: this.sort_by,
        sort_order: this.sort_order,
        fields,
        revokedOnly: this.additionalOptions[0].value,
        users: this.tableComponent.selectedAll
          ? []
          : this.tableComponent.selectedOptions.map((item: any) => item.user_id)
      };

      const res: any = await this.driveAttendanceService.downloadData(payload);
      this.clearInputs();

      if (res?.success) {
        this.messageService.add({
          severity: Severity.SUCCESS,
          summary: Summary.SUCCESS,
          detail: Message.BACKGROUNDPROCESSSTARTED
        });
        this.clearInputs();
      } else {
        throw new Error('Failed to download student data');
      }
    } catch (err: any) {
      this.messageService.add({
        severity: Severity.ERROR,
        summary: Summary.ERROR,
        detail: err?.message || 'An unexpected error occurred during download'
      });
    }
  }

  onDropDownChange(index: number) {

    this.downloadCategories[index].isSelectedAll = this.downloadCategories[index].data.every((element: any) => element.active);
    this.selectedFieldOrder= modifyDownloadFieldsArray(this.selectedFieldOrder,this.downloadCategories[index].data)
  }

  selectAllDownloadData(index: number) {
    this.downloadCategories[index].data.forEach((element: any) => {
      element.active = this.downloadCategories[index].isSelectedAll;
    });
    this.onDropDownChange(index);
  }

  fileFormat(event: any) {
    this.downloadColumnAs = event;
  }

  async fetchStudentList(enableLoader: boolean = true) {
    if (!this.selectedRound) return;

    if (enableLoader) {
      this.fetchingStudents = true;
    }

    try {
      const response = await this.driveAttendanceService.fetchStudents({
        drive_id: this.drive_id,
        round_id: this.selectedRound?.event_id,
        rowSize: this.rowsize,
        page: this.selectedPage,
        search: this.searchValue,
        sort_by: this.sort_by,
        sort_order: this.sort_order,
        revokedOnly: this.additionalOptions[0].value
      });

      if (!response.success) {
        this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Error Fetching Student List' });
        this.fetchingStudents = false;
        return;
      }

      this.dataList = response?.data?.data;
      this.dataCount = response?.data?.meta?.total;
      this.totalPage = Math.ceil(this.dataCount / this.rowsize);

      if (this.tableComponent) {
        this.tableComponent.resetSelected();
      }

      if (enableLoader) {
        this.fetchingStudents = false;
      }
    } catch (error) {
      console.error('Error in fetchStudentList:', error);
      this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Unexpected Error While Fetching Student List' });
    }
  }

  async fetchAttendanceConfig() {
    if (!this.selectedRound) return;

    try {
      const response = await this.driveAttendanceService.fetchAttendance({
        drive_id: this.drive_id,
        round_id: this.selectedRound?.event_id
      });

      if (!response.success) {
        this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Error Fetching Student List' });
        return;
      }

      this.gpsLockStatus = response.data?.gps_enabled ? 'enabled' : 'disabled';
      this.gpsFetchMode = response.data?.gps_type;
      this.allowedRadius = response.data?.allowed_radius;
      this.gpsLock = {
        lat: response.data?.gps_lat,
        lng: response.data?.gps_lng
      }
    } catch (error) {
      console.error('Error in fetchStudentList:', error);
      this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Unexpected Error While Fetching Student List' });
    }
  }

  async onRoundSelect(round: IRoundData) {
    try {
      this.autoRefresh = false;
      this.selectedRound = round;
      this.clearData();
      await this.fetchAttendance();
    } catch (error) {
      console.error('Error in onRoundSelect:', error);
      this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Error Selecting Round' });
    }
  }

  async searchValueChange(searchValue: any) {
    this.searchValue = searchValue;
    this.selectedPage = 1;
    await this.fetchStudentList();
  }

  async sortChange(event: any) {
    this.sort_by = event.field;
    this.sort_order = event.order;
    await this.fetchStudentList();
  }

  async rowLengthChange(length: any) {
    this.rowsize = length;
    this.selectedPage = 1;
    await this.fetchStudentList();
  }

  async pageChange(selectedPage: any) {
    this.selectedPage = selectedPage;
    await this.fetchStudentList();
  };

  // fetchCurrentLocation() {
  //   this.stopGeneration();
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         console.log(position)
  //         this.gpsLock.lat = +position.coords.latitude.toFixed(6);
  //         this.gpsLock.lng = +position.coords.longitude.toFixed(6);
  //         this.messageService.add({ severity: Severity.SUCCESS, summary: Summary.SUCCESS, detail: 'Location fetched' });
  //       },
  //       () => {
  //         this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Unable to fetch location' });
  //       }
  //     );
  //   } else {
  //     this.messageService.add({ severity: Severity.WARN, summary: Summary.WARNING, detail: 'Geolocation not supported' });
  //   }
  // }

  // Comprehensive robust location fetching method
  async fetchCurrentLocationRobust() {
    this.stopGeneration();

    try {
      // First attempt: High accuracy GPS with optimized settings
      if (navigator.geolocation) {
        const position: any = await this.getGPSLocationWithRetry();
        this.gpsLock.lat = +position.coords.latitude.toFixed(6);
        this.gpsLock.lng = +position.coords.longitude.toFixed(6);

        const accuracy = position.coords.accuracy ?
          ` (±${Math.round(position.coords.accuracy)}m)` : '';

        this.messageService.add({
          severity: Severity.SUCCESS,
          summary: Summary.SUCCESS,
          detail: `Precise location fetched${accuracy}`
        });
        return;
      }
    } catch (gpsError) {
      if (gpsError instanceof Error) {
        console.log('GPS location failed:', gpsError?.message);
      }

      console.error('All location methods failed:', gpsError);
      this.messageService.add({
        severity: Severity.ERROR,
        summary: Summary.ERROR,
        detail: 'Unable to fetch location from any source'
      });
    } finally {
      this.fetchingLocation = false;
    }
  }

  // Enhanced GPS location with retry logic and platform detection
  async getGPSLocationWithRetry(maxRetries = 3) {
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    // const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);

    // Platform-optimized options
    let baseOptions = {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 30000 // 5 minutes cache
    };

    // iOS/Safari optimizations
    // if (isIOS || isSafari) {
    //   baseOptions = {
    //     enableHighAccuracy: false, // Start conservative for iOS
    //     timeout: 15000,
    //     maximumAge: 30000
    //   };
    // }

    // iOS/Safari optimizations
    // if (isIOS || isSafari) {
    //   baseOptions = {
    //     enableHighAccuracy: false, // Start conservative for iOS
    //     timeout: 15000,
    //     maximumAge: 600000 // 10 minutes cache for iOS
    //   };
    // }

    let lastError;

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        console.log(`GPS attempt ${attempt}/${maxRetries}`);

        const options = {
          ...baseOptions,
          timeout: baseOptions.timeout + (3000 * (attempt - 1)),
          enableHighAccuracy: attempt > 1 ? true : baseOptions.enableHighAccuracy
        };

        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, options);
        });

        return position;

      } catch (error) {
        lastError = error;

        if (error instanceof Error) {
          console.log(`GPS attempt ${attempt} failed:`, error?.message);
        } else {
          console.log(`GPS attempt ${attempt} failed with unknown error:`, error);
        }

        // Handle specific Geolocation errors
        if (this.isGeolocationPositionError(error) && error.code === 2 && attempt < maxRetries) {
          try {
            console.log('Trying watchPosition fallback...');
            const watchPosition = await this.tryWatchPosition();
            return watchPosition;
          } catch (watchError) {
            console.log('WatchPosition also failed');
          }
        }

        // Wait before retrying
        if (attempt < maxRetries) {
          await this.delay(500 * attempt);
        }
      }
    }
    throw lastError;
  }

  isGeolocationPositionError(error: unknown): error is GeolocationPositionError {
    return (
      typeof error === 'object' &&
      error !== null &&
      'code' in error &&
      typeof (error as any).code === 'number'
    );
  }

  // WatchPosition fallback for when getCurrentPosition fails
  async tryWatchPosition() {
    return new Promise((resolve, reject) => {
      let watchId: any;
      let resolved = false;
      let timeout: any;

      const options = {
        enableHighAccuracy: false,
        timeout: 20000,
        maximumAge: 0
      };

      // Overall timeout
      timeout = setTimeout(() => {
        if (!resolved && watchId) {
          resolved = true;
          navigator.geolocation.clearWatch(watchId);
          reject(new Error('Watch position timeout'));
        }
      }, 18000);

      watchId = navigator.geolocation.watchPosition(
        (position) => {
          if (!resolved) {
            resolved = true;
            clearTimeout(timeout);
            navigator.geolocation.clearWatch(watchId);
            resolve(position);
          }
        },
        (error) => {
          if (!resolved) {
            resolved = true;
            clearTimeout(timeout);
            navigator.geolocation.clearWatch(watchId);
            reject(error);
          }
        },
        options
      );
    });
  }

  handleLocationError(error: any) {
    let message = '';
    let severity = Severity.ERROR;

    switch (error.code) {
      case error.PERMISSION_DENIED:
        message = 'Location access denied. Please enable location permissions in your browser settings.';
        severity = Severity.WARN;
        break;
      case error.POSITION_UNAVAILABLE:
        message = 'Location unavailable. Please check your GPS signal or internet connection.';
        severity = Severity.WARN;
        break;
      case error.TIMEOUT:
        message = 'Location request timed out. Please try again.';
        severity = Severity.WARN;
        break;
      default:
        message = 'Unable to retrieve location. Please check your device settings.';
        break;
    }

    this.messageService.add({
      severity: severity,
      summary: Summary.ERROR,
      detail: message
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async fetchLocationWithStrategy(strategy = 'robust') {
    this.stopGeneration();
    this.fetchingLocation = true;

    try {
      switch (strategy) {
        case 'gps-only':
          try {
            const position = await this.getGPSLocationWithRetry(1);
            this.handleLocationSuccess(position, 'GPS Only');
          } catch (error) {
            this.handleLocationError(error);
          }
          break;

        // case 'fast':
        //   // Try both GPS and IP simultaneously, use whichever responds first
        //   await Promise.race([
        //     this.getGPSLocationWithRetry(1).then(pos => this.handleLocationSuccess(pos, 'GPS')),
        //     this.fetchLocationByIP().then(success => {
        //       if (success) {
        //         this.messageService.add({
        //           severity: Severity.SUCCESS,
        //           summary: Summary.SUCCESS,
        //           detail: 'Fast location via IP'
        //         });
        //       }
        //     })
        //   ]);
        //   break;

        default:
          await this.fetchCurrentLocationRobust();
      }
    } catch (error) {
      console.log("Error in fetchLocationWithStrategy:", error);
    }
  }

  // Helper method for successful location handling
  handleLocationSuccess(position: any, source = 'GPS') {
    this.gpsLock.lat = +position.coords.latitude.toFixed(6);
    this.gpsLock.lng = +position.coords.longitude.toFixed(6);

    const accuracy = position.coords.accuracy ?
      ` (±${Math.round(position.coords.accuracy)}m)` : '';

    this.messageService.add({
      severity: Severity.SUCCESS,
      summary: Summary.SUCCESS,
      detail: `Location fetched via ${source}${accuracy}`
    });
  }

  canGenerateQR(): boolean {
    if (this.gpsLockStatus === 'disabled') return true;
    if (!this.allowedRadius || !this.gpsLock.lat || !this.gpsLock.lng) return false;
    return true;
  }

  async generateQRCode(cycle_id: string, startInterval = false) {
    const qrBody = {
      cycle_id,
      drive_id: this.drive_id,
      round_id: this.selectedRound?.event_id,
      ...(this.gpsLockStatus === 'enabled' ? { gpsLock: this.gpsLock, radius: this.allowedRadius } : {}),
      timestamp: Date.now(),
      group_account_id: this.group_account_id,
      expires_at: Date.now() + 10000 //current timestamp + 5 seconds for buffer
      // expires_at: Date.now() + 12 * 60 * 60 * 1000  // 12 hours in milliseconds for testing
    };

    const payload: any = {
      drive_id: this.drive_id,
      round_id: this.selectedRound?.event_id,
      attendance_config: {
        gps_enabled: this.gpsLockStatus === 'enabled',
        allowed_radius: this.allowedRadius,
        gps_lat: this.gpsLock.lat,
        gps_lng: this.gpsLock.lng,
        gps_type: this.gpsLockStatus === 'enabled' ? this.gpsFetchMode : null
      }
    };

    const jsonStr = JSON.stringify(qrBody);
    const encryptedData = btoa(jsonStr);
    const embedURL = `https://native.neopat.ai/scanner/scan?token=${encodeURIComponent(encryptedData)}`;

    this.generatingQR = true;
    if (!this.qrRefreshInterval) {
      await this.driveAttendanceService.saveAttendance(payload);
    }

    try {
      const qrCodeData = await QRCode.toDataURL(embedURL);
      this.qrCodeUrl = qrCodeData;
      this.nextRefreshIn = 5;
      this.generatingQR = true;

      if (startInterval && !this.qrRefreshInterval) {
        this.qrRefreshInterval = setInterval(() => {
          this.generateQRCode(cycle_id);
        }, 5000);

        this.startCountdown();
      }
    } catch (error) {
      this.generatingQR = false;
      this.messageService.add({ severity: Severity.ERROR, summary: Summary.ERROR, detail: 'Error generating QR Code' });
      console.error("Error generating QR code", error);
    }
  }

  async logQRGenerationStart(cycleId: string) {
    const logData = {
      cycle_id: cycleId,
      drive_id: this.drive_id,
      round_id: this.selectedRound?.event_id,
      gps_lock_enabled: this.gpsLockStatus === 'enabled',
      ...(this.gpsLockStatus === 'enabled' ? { gpsLock: this.gpsLock } : {}),
      radius: this.allowedRadius ?? 0,
      start_time: Date.now(),
      status: 'active',
      group_account_id: this.group_account_id || '',
      generated_by: this.userData?.user_id || '',
      generated_by_email: this.userData?.primary_email || '',
    };

    const docRef = await addDoc(collection(this.firestore, 'qr_logs'), logData);
    this.qrLogDocId = docRef.id;
  }

  async logQRGenerationStop() {
    if (!this.qrLogDocId) return;
    const docRef = doc(this.firestore, 'qr_logs', this.qrLogDocId);
    await updateDoc(docRef, {
      end_time: Date.now(),
      status: 'stopped'
    });
    this.qrLogDocId = null;
  }

  stopGeneration() {
    this.cycleId = '';
    this.creatingQR = false;
    this.logQRGenerationStop();
    this.qrCodeUrl = '';
    this.generatingQR = false;
    this.nextRefreshIn = 0;
    if (this.qrRefreshInterval) {
      clearInterval(this.qrRefreshInterval)
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  startCountdown() {
    clearInterval(this.refreshTimer);
    this.refreshTimer = setInterval(() => {
      if (this.nextRefreshIn > 0) {
        this.nextRefreshIn--;
      }
    }, 1000);
  }

  startQRCodeProcess() {
    this.isQrInAnotherTab = false;
    this.cycleId = this.generateFallbackId();
    this.logQRGenerationStart(this.cycleId);

    if (this.qrRefreshInterval) {
      clearInterval(this.qrRefreshInterval);
      this.qrRefreshInterval = null;
    }
    this.generateQRCode(this.cycleId, true);
  }

  generateFallbackId(): string {
    return 'qr_' + Math.random().toString(36).substring(2, 10) + Date.now();
  }

  openQRInFullscreen() {
    const img = document.getElementById("qrImage");
    if (img && img.requestFullscreen) {
      img.requestFullscreen();
    }
  }

  openQRInNewTab() {
    const newTab = window.open('/qr', '_blank');

    const qrData = {
      qrCodeUrl: this.qrCodeUrl,
      nextRefreshIn: this.nextRefreshIn,
      timestamp: Date.now(),
      drive_id: this.drive_id,
      round_id: this.selectedRound?.event_id,
      gps_enabled: this.gpsLockStatus === 'enabled',
      radius: this.allowedRadius,
      gps_lat: this.gpsLock.lat,
      gps_lng: this.gpsLock.lng,
      group_account_id: this.group_account_id,
      cycle_id: this.cycleId,
      gpsFetchMode: this.gpsFetchMode
    };

    const sendData = () => {
      if (newTab) {
        newTab.postMessage({ type: 'QR_DATA', data: qrData }, '*');
      }
    };

    const interval = setInterval(() => {
      if (newTab && newTab.document.readyState === 'complete') {
        clearInterval(interval);
        sendData();
      }
    }, 100);

    this.isQrInAnotherTab = true;
    this.generatingQR = false;
    this.stopGeneration();
  }

  lockTypeChange() {
    if (this.gpsLockStatus === 'enabled') {
      this.allowedRadius = 100;
    } else {
      this.allowedRadius = 0;
      this.gpsLock = {
        lat: null,
        lng: null
      };
    }
    this.stopGeneration();
  }

  handleAutoRefreshToggle() {
    if (this.autoRefresh) {
      this.autoRefreshInterval = setInterval(() => {
        this.fetchStudentList(false);
      }, 10000);
    } else {
      clearInterval(this.autoRefreshInterval);
    }
  }

  clearData() {
    this.stopGeneration();
    this.gpsLock = { lat: 0, lng: 0 };
    this.allowedRadius = 0;
    this.gpsLockStatus = 'disabled';
    this.additionalOptions.forEach((item: any) => {
      item.value = false;
    });
  }

  onDialogClose() {
    this.displayRevokeReason = false;
    this.revokeReason = '';
    this.revokePayload = {};
  }

  ngOnDestroy() {
    this.autoRefresh = false;
    this.cycleId = '';
    if (this.qrRefreshInterval) {
      clearInterval(this.qrRefreshInterval);
    }
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
    if (this.autoRefreshInterval) {
      clearInterval(this.autoRefreshInterval);
    }
  }
}